import { ACTION_TYPES } from '../constants/actions';

export interface OrderPair {
  customerId: string;
  orderId: string;
  addedAt?: number;
}

export interface OrderPairsState {
  pairs: OrderPair[];
}

export const initialState: OrderPairsState = {
  pairs: []
};

const orderPairsReducer = (
  state = initialState,
  action: any
): OrderPairsState => {
  switch (action.type) {
    case ACTION_TYPES.ORDER_PAIRS.ADD_PAIR: {
      const { customerId, orderId } = action.payload;
      const newPair: OrderPair = {
        customerId,
        orderId,
        addedAt: Date.now()
      };
      return {
        ...state,
        pairs: [...state.pairs, newPair]
      };
    }

    case ACTION_TYPES.ORDER_PAIRS.RESET_PAIRS: {
      return initialState;
    }

    case ACTION_TYPES.ORDER.RESET_ORDER:
    case ACTION_TYPES.PAYMENT.CLEAR_BUY_FLOW_DATA: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default orderPairsReducer;
